import React, { useEffect } from "react";
import Header from '../components/header'; 
import Footer from '../components/footer'; 
import AOS from "aos";
import "aos/dist/aos.css";

const Banquet = () => {

useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  return (
    <div>
      <Header />
      
<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/9.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Our Banquet</div>
					</div>
				</div>
			</div>
		</div>
	</div>

 <section className="py-5 bg-light position-relative overflow-hidden">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Content */}
          <div 
            className="col-lg-6 mb-5 mb-lg-0"
            data-aos="fade-right"
          >
            <span className="badge bg-gradient px-3 py-2 mb-3 fs-6 shadow-sm">
              OUR BANQUET HALL
            </span>

            <h3 className="fw-bold mb-4">
             Welcome to Pahadi Convention – <span className="text-primary"> Where Celebrations Find Their Grandeur</span>
            </h3>

            <p>
             Nestled in the heart of Vedvyas, Rourkela, Pahadi Convention is a distinguished venue designed to host celebrations, conferences, and grand gatherings with elegance and ease. Whether you are planning a lavish wedding, a corporate seminar, or a cultural function, our banquet halls offer the perfect blend of space, sophistication, and seamless service.
            </p>
            <p>
              With spacious interiors, modern amenities, and a dedicated hospitality team, Pahadi Convention transforms every event into a memorable experience.
            </p>

            
            
          </div>

          {/* Right Image */}
          <div 
            className="col-lg-6 text-center"
            data-aos="fade-left"
          >
            <div className="position-relative">
              <img 
                src="img/1.jpeg" 
                alt="Hotel Room"
                className="img-fluid rounded-4 shadow-lg about-img"
              />
            </div>
          </div>

           

        </div>
      </div>
      <section class="rajdarbar-section py-5">
  <div class="container">
    <div class="row align-items-center g-4">
      
       <div class="col-12 col-lg-6 text-center">
        <img 
          src="img/1.jpeg" 
          alt="Rajdarbar Celebration Hall" 
          class="img-fluid rounded shadow"
        />
      </div>
      
      <div class="col-12 col-lg-6">
        <h4 class="fw-bold mb-3">Rajdarbar – The Grand Celebration Hall</h4>
        
        <p class="text-muted mb-2"><strong>Capacity:</strong> Up to 500 Guests</p>
        
        <p>
          True to its name, Rajdarbar reflects royalty and magnificence. 
          Designed to accommodate up to 500 guests, this grand hall is ideal for:
        </p>

        <ul class="mb-4">
          <li>Lavish weddings & receptions</li>
          <li>Engagement ceremonies</li>
          <li>Corporate conferences & annual meets</li>
          <li>Cultural events & award functions</li>
          <li>Large social gatherings</li>
        </ul>

        <h5 class="fw-semibold">Key Highlights:</h5>
        <ul>
          <li>Spacious seating arrangements</li>
          <li>Elegant stage setup area</li>
          <li>Customizable décor options</li>
          <li>Advanced lighting & sound provisions</li>
          <li>Comfortable ambiance for large-scale events</li>
        </ul>

        <p class="mt-3">
          Rajdarbar offers the scale and sophistication required for grand occasions, 
          ensuring your event leaves a lasting impression.
        </p>
      </div>

     
    

    </div>
  </div>
</section>

  <section class="rajdarbar-section py-5">
  <div class="container">
    <div class="row align-items-center g-4">
      
    
      
      <div class="col-12 col-lg-6">
        <h4 class="fw-bold mb-3">Brahmani – Perfect for Mid-Size Gatherings</h4>
        
        <p class="text-muted mb-2"><strong>Capacity:</strong> Up to 250 Guests</p>
        
        <p>
          Named after the sacred Brahmani River flowing near Vedvyas, Brahmani Hall is an ideal venue for elegant mid-sized events, accommodating up to 250 guests comfortably.
        </p>
        <h6 class="fw-semibold">Perfect for:</h6>
        <ul class="mb-4">
          <li>Birthday parties & anniversaries</li>
          <li>Ring ceremonies</li>
          <li>Corporate seminars & workshops</li>
          <li>Private receptions</li>
          <li>Community meetings</li>
        </ul>

        <h6 class="fw-semibold">Key Highlights:</h6>
        <ul>
        <li>Well-planned seating layout</li>
        <li>Stage & presentation-ready setup</li>
        <li>Pleasant ambiance</li>
        <li>Flexible décor themes</li>
        <li>Dedicated support staff</li>
        </ul>

        <p class="mt-3">
         Brahmani Hall ensures an intimate yet spacious setting for your special moments.
        </p>

         <h6 class="fw-semibold">Why Choose Pahadi Convention?</h6>
       
        ✔ Prime location at Vedvyas, Rourkela <br></br>
✔ Ample space for both grand and mid-size events<br></br>
✔ Professional event coordination<br></br>
✔ Modern facilities & infrastructure<br></br>
✔ Customizable setup as per event needs<br></br>


      
      </div>
   <div class="col-12 col-lg-6 text-center">
        <img 
          src="img/1.jpeg" 
          alt="Rajdarbar Celebration Hall" 
          class="img-fluid rounded shadow"
        />
      </div>
       <p class="mt-3">
         At Pahadi Convention, every celebration is handled with care, precision, and passion. From décor to coordination, we ensure your event runs smoothly from start to finish.
        </p>
    

    </div>
  </div>
</section>
      {/* Decorative Shape */}
      <div className="position-absolute top-0 end-0 opacity-25">
        <div className="bg-primary rounded-circle shape-circle"></div>
      </div>
    </section>

 
<br />
        <Footer />
    </div>
  )
}

export default Banquet;